import { memo } from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';

import ChangeLanguageMobile from '../changeLanguageMobile';

const _DrawerMobile = ({
	show,
	currLang,
	languagesMap,
	handleSwitch,
	options,
	cta,
	phone,
	faqs,
}) => {
	return (
		<section
			aria-expanded={show}
			className={`cc-drawer cc-drawer--mobile ${show ? 'cc-drawer--show' : ''}`}
		>
			<div className="cc-drawer__hamburger">
				{options.map(({ link, title }) => (
					<Link key={link} className="cc-drawer__hamburger-item" to={link}>
						{title}
					</Link>
				))}
				<ChangeLanguageMobile
					currLang={currLang}
					languagesMap={languagesMap}
					handleSwitch={handleSwitch}
				/>
				<a
					className="link link--no-underline btn btn--outlined"
					href={cta.link}
					target="_blank"
					rel="noreferrer"
				>
					{cta.title}
				</a>
				<div className="cc-drawer__hamburger-item">
					<a
						className="cc-drawer__hamburger-link"
						href={`tel:${phone.cta.link}`}
					>
						{phone.cta.link}
					</a>
					<Link className="cc-drawer__hamburger-link" to={faqs.cta.link}>
						{faqs.cta.title}
					</Link>
				</div>
			</div>
		</section>
	);
};

_DrawerMobile.propTypes = {
	show: PropTypes.bool,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired,
		})
	).isRequired,
	cta: PropTypes.shape({
		title: PropTypes.string.isRequired,
		link: PropTypes.string.isRequired,
	}).isRequired,
	phone: PropTypes.shape({
		cta: PropTypes.shape({
			title: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired,
		}),
		title: PropTypes.string.isRequired,
		icon: PropTypes.object.isRequired,
		description: PropTypes.shape({
			raw: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	faqs: PropTypes.shape({
		cta: PropTypes.shape({
			title: PropTypes.string.isRequired,
			link: PropTypes.string.isRequired,
		}),
		title: PropTypes.string.isRequired,
		icon: PropTypes.object.isRequired,
		description: PropTypes.shape({
			raw: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	languagesMap: PropTypes.object,
	handleSwitch: PropTypes.func,
	currLang: PropTypes.string,
};

_DrawerMobile.defaultProps = {
	show: false,
};

const Drawer = memo(_DrawerMobile);

export default Drawer;
